import { PrimaryButton, SecondaryButton, useModal } from '@shape-ds/components';
import { isValidElement, ReactElement } from 'react';
import { ModalWidthEnum } from './GenericModal';
import './Modal.scss';

interface HeaderProps {
  title: string | ReactElement;
}
interface BodyProps {
  description?: string | ReactElement;
}

interface Button {
  text: string;
  onClick?: () => void;
}
interface Footer {
  primary?: Button;
  secondary?: Button;
  className?: string;
}

interface FooterProps {
  footer?: Footer | ReactElement;
}

interface Props extends HeaderProps, BodyProps, FooterProps {
  className?: string;
  width?: ModalWidthEnum;
}

const Header = ({ title }: HeaderProps) => {
  return <div className="modal-header">{title}</div>;
};

const Body = ({ description }: BodyProps) => {
  return <div className="modal-body">{description}</div>;
};

const Footer = ({ footer }: FooterProps) => {
  const { closeModal } = useModal();
  if (!footer) return null;

  if (isValidElement(footer)) {
    return <div className="modal-footer">{footer}</div>;
  }

  const { primary, secondary, className = '' } = footer as Footer;

  return (
    <div className={`modal-footer ${className}`}>
      {secondary && (
        <SecondaryButton
          onClick={secondary?.onClick ?? closeModal}
          className="modal-footer-button-secondary"
        >
          {secondary.text}
        </SecondaryButton>
      )}
      {primary && (
        <PrimaryButton onClick={primary?.onClick} className="modal-footer-button-primary">
          {primary.text}
        </PrimaryButton>
      )}
    </div>
  );
};

const Modal = ({
  className = '',
  description,
  footer,
  title,
  width = ModalWidthEnum.MEDIUM,
}: Props) => {
  return (
    <div className={`modal-wrapper modal-${width} ${className}`}>
      <Header title={title} />
      <Body description={description} />
      <Footer footer={footer} />
    </div>
  );
};

export default Modal;
